export default __webpack_public_path__ + "static/convirza-5d648057dae9d2a1561e6c3c2e154480.png";